var baseStyleCloseButton = {
  fontSize: 'xs',
  w: 8,
  h: 8,
  ml: 5,
  borderRadius: '0',
  color: 'white',
  _disabled: {
    opacity: 0.4
  },
  _focus: {
    boxShadow: "none",
    color: 'grey.980',
    bg: 'yellow.200'
  }
};
var baseStyle = {
  container: {
    borderRadius: '0'
  },
  closeButton: baseStyleCloseButton
};
export var Tag = {
  baseStyle
};